import type { CreateElement } from 'vue';

import { useRoutingStore } from '@/helpers/composables/useStores';
import { computed } from 'vue';

export default {
	setup() {
		const { urlMetadata } = useRoutingStore();

		const styles = computed(() => urlMetadata.value?.htmlContentJson?.styles ?? null);

		return (h: CreateElement) => h('style', { domProps: { innerHTML: styles.value } });
	},
};
